import { Injectable } from "@angular/core";
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";

@Injectable()
export class NgbMonthDayYearFormatParser extends NgbDateParserFormatter {
  readonly DT_FORMAT = "MM/DD/YYYY";
  readonly DATE_FORMAT: RegExp =
    /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/;

  parse(value: string): NgbDateStruct {
    console.log("Parsing ...");
    if (value) {
      value = value.trim();
      const is = this.DATE_FORMAT.test(value);
      if (!is) {
        return null;
      } // not a date format we care about

      const d = moment(value, this.DT_FORMAT);
      return {
        year: parseInt(moment.utc(d).format("YYYY"), 10),
        day: parseInt(moment.utc(d).format("D"), 10),
        month: parseInt(moment.utc(d).format("M"), 10),
      };
    }

    return null;
  }

  format(date: NgbDateStruct): string {
    console.log("Formatting ...");
    if (!date) {
      return "";
    }
    console.log(date);
    const mdt = moment.utc([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) {
      return "";
    }
    return mdt.format(this.DT_FORMAT);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/typeable-date-picker/ngb-month-day-year-format-parser.ts